import { Divider, Group, SimpleGrid, Skeleton, Stack, VisuallyHidden } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

// Adresse, contacts, transmission, seuils, DPI, coordonnées.
const SECTION_COUNT = 6;

/** Squelette de `SusFormDrawer` affiché pendant le chargement du service d'urgence. */
const SusFormDrawerLoader = () => {
  const { t } = useTranslate();

  return (
    <Stack gap="md" role="status" aria-busy="true">
      <VisuallyHidden>{t('admin.sus.form.loading')}</VisuallyHidden>
      <Skeleton height={12} width="40%" aria-hidden="true" />
      <Stack gap={6} aria-hidden="true">
        <Skeleton height={14} width="30%" />
        <Skeleton height={36} />
      </Stack>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs" aria-hidden="true">
        {Array.from({ length: 2 }, (_, index) => (
          <Stack key={index} gap={6}>
            <Skeleton height={14} width="50%" />
            <Skeleton height={36} />
          </Stack>
        ))}
      </SimpleGrid>
      <Stack gap={6} aria-hidden="true">
        <Skeleton height={14} width="30%" />
        <Skeleton height={36} />
      </Stack>
      {Array.from({ length: SECTION_COUNT }, (_, index) => (
        <Stack key={index} gap="md" aria-hidden="true">
          <Divider />
          <Skeleton height={20} width="40%" />
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
            <Skeleton height={36} />
            <Skeleton height={36} />
          </SimpleGrid>
        </Stack>
      ))}
      <Group justify="flex-end" py="sm" aria-hidden="true">
        <Skeleton height={36} width={100} />
        <Skeleton height={36} width={120} />
      </Group>
    </Stack>
  );
};

export default SusFormDrawerLoader;
